import { type InjectionKey } from 'vue'
import { type Provide } from './PmPackingContainerPure.vue'

export const packingContainerKey = Symbol(
  'packingContainer'
) as InjectionKey<Provide>
